/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_Models_TitleInputs */

const en_directory_tools_models_title = /** @type {(inputs: Directory_Tools_Models_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI model catalog`)
};

const zh_directory_tools_models_title = /** @type {(inputs: Directory_Tools_Models_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 模型目录`)
};

/**
* | output |
* | --- |
* | "AI model catalog" |
*
* @param {Directory_Tools_Models_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_models_title = /** @type {((inputs?: Directory_Tools_Models_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Models_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_models_title(inputs)
	return zh_directory_tools_models_title(inputs)
});
export { directory_tools_models_title as "directory.tools.models.title" }